import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { Action } from '../../../action';
import { getCatchError } from '../../../getCatchError';

const setCreateUser = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_USERS_CASHIERS
            });
            dispatch(Action.SetUsers({
                groups: params.groups,
                cashier: '',
            }));
        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setCreateUser as SetCreateUser
}